import * as React from "react";
import { ISpbFooter, ISpbHeader, ISpbNavbar, SpbHeader, SpbNavbar, } from "../..";
import { SpbFooter } from "../footer/Footer";
import { IleftBg, LeftBg } from "../leftBg";
import { ISpbFooterNotification, SpbFooterNotification } from "../footer_notification";
import "./layout.css"
import "./layout.scss"


export interface ISpbLayout {
  header?: JSX.Element | ISpbHeader;
  footer?: JSX.Element | ISpbFooter;
  navbar?: JSX.Element | ISpbNavbar;
  leftBg?: JSX.Element | IleftBg;
  footerNotification?:JSX.Element | ISpbFooterNotification;
}

export const SpbLayout: React.FC<ISpbLayout> = ({ header, footer,footerNotification, navbar, leftBg, children }): JSX.Element => {
  return (
    <div className="d-flex flex-row layoutContainer">

      {React.isValidElement(navbar) ?
        navbar
        :
        <SpbNavbar {...navbar as ISpbNavbar} />
      }
      {React.isValidElement(navbar) ?
        navbar
        :
        <LeftBg{...leftBg as IleftBg} />
      }
      <div className={'spb-layout-container'}>
        <div className="flex-1-1" >
        {React.isValidElement(header) ?
          header
          :
          <SpbHeader {...header as ISpbHeader} />
        }

        {children}
        </div>
        {React.isValidElement(footerNotification) ?
          footerNotification
          :
          <SpbFooterNotification {...footerNotification as ISpbFooterNotification} />
        }
        {React.isValidElement(footer) ?
          footer
          :
          <SpbFooter {...footer as ISpbFooter} />
        }
      </div>
    </div>
  );
};
